import React, { useEffect, useState } from 'react';
import Layout from '../Layout';
import { Typography, Container, Box, Grid, Button } from '@material-ui/core';
import { useLocation } from 'react-router-dom';
import CustomBreadcrumbs from '../Breadcrumb';
import { useDispatch } from 'react-redux';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { getAssetPLILogs } from '../../ReduxStore/AssetDisposalSlice';
import PLI1 from '../../images/PLI1.jpg'
import PLI2 from '../../images/PLI2New.png'
import jsPDF from 'jspdf';
import 'jspdf-autotable';
import { GridLoadingSpinner } from '@tmlconnected/avant-garde-components-library';
import { getSafeHttpUrl } from '../../utils/safeUrl';


const PLIDetails = () => {
    const dispatch = useDispatch();
    const breadcrumbsLinks = [
        { label: 'Home', href: '/' }
    ];
    const location = useLocation();
    const pathname = location.pathname.split('/');
    const pli_id = pathname[2];

    const [loading, setLoading] = useState(true);
    const [assetPLIDetails, setAssetPLIDetails] = useState({});
    const [attachedFiles, setAttachedFiles] = useState([]);


    const getAssetPLIDetails = async () => {
        try {
            const action = dispatch(getAssetPLILogs(`?id=${pli_id}`));
            const res = await action.unwrap();
            console.log("uuuuuuuuuuuuuuuuuu", res.result)
            if (res.result) {
                setAssetPLIDetails(res.result)
            };
            if (res.result?.attached_files?.length > 0) {
                setAttachedFiles(res.result?.attached_files)
            }
        } catch (error) {
            console.error("Error in okHandler:", error);
            toast.error(error.message || "No Logs Found!");
        }
    }

    const getBase64ImageFromURL = (url) => {
        return new Promise((resolve, reject) => {
            let img = new Image();
            img.setAttribute('crossOrigin', 'anonymous'); // Handle CORS for images
            img.src = url;
            img.onload = () => {
                let canvas = document.createElement('canvas');
                canvas.width = img.width;
                canvas.height = img.height;
                let ctx = canvas.getContext('2d');
                ctx.drawImage(img, 0, 0);
                let dataURL = canvas.toDataURL('image/jpeg'); // Or 'image/png'
                resolve(dataURL);
            };
            img.onerror = (error) => reject(error);
        });
    };

    const generatePDF = async () => {
        const doc = new jsPDF();
        // Convert images to base64
        const base64Icon1 = await getBase64ImageFromURL(PLI1);
        const base64Icon2 = await getBase64ImageFromURL(PLI2);

        // Add icons in the top corners with smaller size (15x15)
        doc.addImage(base64Icon1, 'JPEG', 20, 10, 15, 15);  // Left top corner
        doc.addImage(base64Icon2, 'JPEG', 170, 10, 15, 15); // Right top corner

        doc.setFontSize(12); // Set font size for title
        doc.setFont("helvetica", "bold"); // Set font to bold
        doc.text('Annexure-V-C: Photos of Site Visit', 20, 35); // Adjust positioning after icons
        doc.setFont("helvetica", "normal"); // Reset to normal font for subsequent text

        // Adding Instructions
        doc.setFontSize(10);
        // Make the first instruction bold
        doc.setFont("helvetica", "bold");
        doc.text('Photographs should include the following:', 20, 45);
        doc.setFont("helvetica", "normal"); // Reset to normal font for subsequent text

        doc.text('• Few photos of factory entrance with GPS coordinates.', 20, 50);
        doc.text('• External and internal view of factory including manufacturing operations.', 20, 55);
        doc.text('• Photo of visiting team from CE and Company officials.', 20, 60);
        doc.text('• A one-page note covering capex items – sample of at least 30 high value/critical items:', 20, 65);

        // Add the heading for the table just above the table
        doc.setFontSize(12); // Set the font size for the heading
        doc.setFont("helvetica", "bold"); // Set font to bold
        const headingY = 75; // Adjust Y-coordinate to where you want it above the table
        doc.text('Format for one-page note on select capex items:', 20, headingY);

        // Set normal font back for the table contents
        doc.setFont("helvetica", "normal");


        const tableBody = [
            ['#', 'Particulars', 'Details'],
            ['1', 'Machine/ Asset Name', assetPLIDetails.form_data?.asset_name || 'N/A'],
            ['2', 'Model#', assetPLIDetails.form_data?.model || 'N/A'],
            ['3', 'Serial#', assetPLIDetails.form_data?.serial_no || 'N/A'],
            ['4', 'Make/ Manufacturer', assetPLIDetails.form_data?.make || 'N/A'],
            ['5', 'Fixed Asset Code/ Asset ID', (assetPLIDetails.form_data?.asset_code_rfid).slice(3) || 'N/A'],
            ['6', 'Building where installed', assetPLIDetails.form_data?.installation_location || 'N/A'],
            ['7', 'Invoice#', assetPLIDetails.form_data?.invoice_no || 'N/A'],
            ['8', 'Invoice date', assetPLIDetails.form_data?.invoice_date ? new Date(assetPLIDetails.form_data.invoice_date).toLocaleDateString() : 'N/A'],
            ['9', 'Description of Asset as per Invoice', assetPLIDetails.form_data?.asset_description || 'N/A'],
            ['10', 'Name of Seller/ Vendor', assetPLIDetails.form_data?.vendor_no || 'N/A'],
            ['11', 'Status', assetPLIDetails.form_data?.status || 'N/A'],
            ['12', 'Amount Capitalized (₹)', assetPLIDetails.form_data?.amount_capitalized || 'N/A'],
        ];



        // Add the table
        doc.autoTable({
            startY: headingY + 4, // Position the table just below the heading
            // head: [['#', 'Particulars', 'Details']],
            body: tableBody,
            theme: 'grid',
            headStyles: { fillColor: [255, 255, 255], textColor: [0, 0, 0] },
            margin: { top: 75, left: 20, right: 20 },
            styles: { fontSize: 9 },  // Reduce font size in the table to save space
        });

        // Add Photo of Asset section
        doc.text('Photo of Asset:', 20, doc.lastAutoTable.finalY + 10);

        // Define starting position for the images
        let xPos = 20; // X-coordinate of the first image
        let yPos = doc.lastAutoTable.finalY + 15; // Y-coordinate below the "Photo of Asset" heading
        const maxImageWidth = 50; // Maximum width of each image
        const maxImageHeight = 50; // Maximum height of each image
        const margin = 10; // Margin between images

        // Create an array to hold promises for image loading
        const imagePromises = attachedFiles.map(async (file) => {
            const imgUrl = file.url; // Use the URL from the file object
            const img = new Image();
            img.src = imgUrl;

            return new Promise((resolve, reject) => {
                img.onload = async () => {
                    // Calculate aspect ratio
                    const aspectRatio = img.width / img.height;
                    let width, height;

                    // Determine width and height based on aspect ratio
                    if (aspectRatio > 1) {
                        // Landscape
                        width = Math.min(maxImageWidth, img.width);
                        height = width / aspectRatio;
                    } else {
                        // Portrait
                        height = Math.min(maxImageHeight, img.height);
                        width = height * aspectRatio;
                    }

                    // Add image to PDF
                    try {
                        await doc.addImage(imgUrl, 'JPEG', xPos, yPos, width, height);

                        // Update the xPos for the next image
                        xPos += width + margin;

                        // If the next image will overflow the page width, move to the next row
                        if (xPos + width > doc.internal.pageSize.getWidth() - 20) {
                            xPos = 20; // Reset to start of the row
                            yPos += height + margin; // Move down to the next row
                        }
                        resolve(); // Resolve the promise when done
                    } catch (error) {
                        console.error('Error adding image to PDF:', error);
                        reject(error); // Reject the promise if there's an error
                    }
                };

                img.onerror = () => {
                    console.error('Error loading image:', imgUrl);
                    reject(new Error('Image load error'));
                };
            });
        });

        // Wait for all images to load and be added to the PDF
        await Promise.all(imagePromises);


        // Ensure enough space between the last image and the signature section
        yPos += maxImageHeight + margin;



        doc.save('PLI_Form.pdf');
    };

    useEffect(() => {
        const fetchData = async () => {
            await getAssetPLIDetails();
            setLoading(false);
        };
        fetchData();
    }, [])


    if (loading) {
        return (
            <Layout>
                <Container>
                    <Box mt={4} display="flex" justifyContent="center" alignItems="center" minHeight="80vh" >
                        <GridLoadingSpinner />
                    </Box>
                </Container>
            </Layout>
        );
    }
    return (
        <Layout>
            <Container>
                <Box display="flex" justifyContent="space-between" alignItems="center" mb={2} mt={1}>
                    {/* <Typography variant="h5" component="h1" gutterBottom>
                        Asset PLI Details
                    </Typography> */}
                    <Grid item>
                        <Button
                            type="button"
                            variant="contained"
                            color="primary"
                            onClick={generatePDF}
                            fullWidth
                            size='medium'
                        >
                            Generate PDF
                        </Button>
                    </Grid>
                </Box>
                <Box mt={1} mb={2}>
                    <CustomBreadcrumbs links={breadcrumbsLinks} current="Asset PLI Details" />
                </Box>
                <Box className="checkpoint-box" mb={2}>
                    <Grid container spacing={2}>
                        <Grid item xs={6} sm={3}>
                            <strong>Submit By</strong>
                            <h4>{assetPLIDetails?.submitby_name || "N/A"}</h4>
                        </Grid>
                        <Grid item xs={6} sm={3}>
                            <strong>Submit Date</strong>
                            <h4>{new Date(assetPLIDetails?.submit_date).toLocaleString() || "N/A"}</h4>
                        </Grid>
                        <Grid item xs={6} sm={3}>
                            <strong>Vendor No</strong>
                            <h4>{assetPLIDetails?.vendor_no || "N/A"}</h4>
                        </Grid>
                    </Grid>

                    <Box mt={2}>
                        <Grid container spacing={2}>
                            <Grid item xs={6} sm={3}>
                                <strong>Asset No</strong>
                                <h4>{(assetPLIDetails?.form_data?.asset_code_rfid).slice(3) || "N/A"}</h4>
                            </Grid>
                            <Grid item xs={6} sm={3}>
                                <strong>Asset Description</strong>
                                <h4>{assetPLIDetails?.form_data?.asset_description || "N/A"}</h4>
                            </Grid>
                            <Grid item xs={6} sm={3}>
                                <strong>Serial No</strong>
                                <h4>{assetPLIDetails?.form_data?.serial_no || "N/A"}</h4>
                            </Grid>
                            <Grid item xs={6} sm={3}>
                                <strong>Make</strong>
                                <h4>{assetPLIDetails?.form_data?.make || "N/A"}</h4>
                            </Grid>
                            <Grid item xs={6} sm={3}>
                                <strong>Model</strong>
                                <h4>{assetPLIDetails?.form_data?.model || "N/A"}</h4>
                            </Grid>
                            <Grid item xs={6} sm={3}>
                                <strong>Invoice No</strong>
                                <h4>{assetPLIDetails?.form_data?.invoice_no || "N/A"}</h4>
                            </Grid>
                            <Grid item xs={6} sm={3}>
                                <strong>Installation Location</strong>
                                <h4>{assetPLIDetails?.form_data?.installation_location || "N/A"}</h4>
                            </Grid>
                        </Grid>
                    </Box>

                    <Box mt={2}>
                        <strong>Attached Files</strong>
                        <Grid container spacing={2}>
                            {assetPLIDetails?.attached_files?.length > 0 ? (
                                assetPLIDetails.attached_files.map((file, index) => {
                                    const safeUrl = getSafeHttpUrl(file.url);
                                    return (
                                        <Grid item sm={12} key={index}>
                                            {safeUrl ? (
                                                <a
                                                    href={safeUrl}
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                    style={{ textDecoration: 'none', color: 'blue' }}
                                                >
                                                    {file.file_name}
                                                </a>
                                            ) : (
                                                <span>{file.file_name}</span>
                                            )}
                                        </Grid>
                                    );
                                })
                            ) : (
                                <Grid item xs={12}>
                                    <p>No attached files</p>
                                </Grid>
                            )}
                        </Grid>
                    </Box>

                </Box>

            </Container>
            <ToastContainer />
        </Layout>
    );
};

export default PLIDetails;

